module.exports = __webpack_public_path__ + "img/favicon.9371be8e.png";